<div style="width: 420px;margin: 0 auto" class="row pv100">
    <p class="font32 txt-primary bold m0">Ooops...</p>
    <p class="font18">Page Not Found</p>
    <p class="txt-dark-light">The page you are looking for doesn't exit or an other error occurred, go back to home
        page.</p>
    <router-link :to="{ name: 'dashboard' }">
        <button class="btn btn-primary">Go Back</button>
    </router-link>
</div>